import { reactive, toRefs, ref } from 'vue'
import apiLogs from '../api/logs.api'

const state = reactive({
  logs: [],
  filterOptions: {},
  loading: false,
  pagination: ref({
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 0
  }),
  paginationInfoLoading: false
})

const getSummary = async (params) => {
  state.paginationInfoLoading = true

  try {
    const { data: { total } } = await apiLogs.getTotal(params)

    state.pagination.rowsNumber = total
  } catch {
  } finally {
    state.paginationInfoLoading = false
  }
}

export default function useLogs() {

  const getLogs = async (params) => {
    state.loading = true
    getSummary(params)
    const { data } = await apiLogs.getList(params)
    state.logs = Object.freeze(data)
    state.filterOptions = params

    state.pagination.page = params?.page ? params.page : 1
    state.pagination.rowsPerPage = params["page-size"] ? params["page-size"] : 20

    state.loading = false
  }

  return {
    ...toRefs(state),
    getLogs
  }
}